var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_icon",
    "data-name": "Notification icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.015,
    height: 29.019,
    viewBox: "0 0 26.015 29.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Notification_icon-2",
    "data-name": "Notification icon",
    d: "M40.172,37.267C38.593,35.534,39,31.158,39,27.29a8.083,8.083,0,0,0-5.572-7.822,2.756,2.756,0,0,0-5.506,0A8.083,8.083,0,0,0,22.35,27.29c0,3.868.406,8.244-1.173,9.978s-3.51,2.687-3.51,5.33h9.676a3.309,3.309,0,0,0,6.618,0h9.721C43.682,39.954,41.752,39,40.172,37.267Z",
    transform: "translate(-17.667 -16.847)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/Notification icon.9f7df55d73c48cb5576244164a11d9a4.svg";
export { ForwardRef as ReactComponent };